import React, { useState, useContext, useEffect } from "react"

import "react-toastify/dist/ReactToastify.css"
import { QueryClient, QueryClientProvider } from "react-query"

import { createTheme, ThemeProvider } from "@material-ui/core/styles"

import { ColorModeContext } from "./layout/themeContext"
import { SocketContext, SocketManager } from "./context/Socket/SocketContext"

import Routes from "./routes"

import useTimezone from "./hooks/useTimezone"
import {
  registrarEscutaPaginaRestaurada,
  revalidarConversasPaginaRestaurada,
} from "./utils/paginaRestauradaRevalidar"

import { DesignSystem } from "./DesignSystem"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30 * 1000,
      cacheTime: 5 * 60 * 1000,
    },
  },
})

const App = () => {
  const [locale] = useState()

  const { currentMode } = useContext(ColorModeContext)

  useTimezone()

  useEffect(() => registrarEscutaPaginaRestaurada(revalidarConversasPaginaRestaurada), [])

  const theme = createTheme(DesignSystem(currentMode), locale)
  useEffect(() => {
    if (currentMode === "dark") {
      document.body.style.backgroundColor = "black"
    } else {
      document.body.style.backgroundColor = "white"
    }
  }, [currentMode])

  return (
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <SocketContext.Provider value={SocketManager}>
          <Routes />
        </SocketContext.Provider>
      </QueryClientProvider>
    </ThemeProvider>
  )
}

export default App
